import { render, staticRenderFns } from "./SendEmailModal.vue?vue&type=template&id=b267678e&scoped=true&"
import script from "./SendEmailModal.vue?vue&type=script&lang=js&"
export * from "./SendEmailModal.vue?vue&type=script&lang=js&"
import style0 from "./SendEmailModal.vue?vue&type=style&index=0&id=b267678e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b267678e",
  null
  
)

export default component.exports